import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Months } from '../../../models/calendar.model';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    constructor(private http: HttpClient) {
    }

    public getMonths(): Observable<Months[]> {
        return this.http.get<any>("assets/config/months.config.json")
        .pipe(map(val => {
            return val.months;
        }));

    }

}
